// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","item":"Header_item__2VaIS"};